const tecnologias = [
  {
    id: 1,
    titulo: 'React',
    descricao: 'React é uma linguagem de programação utilizada para desenvolver aplicações web e mobile.',
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
  },
  {
    id: 2,
    titulo: 'JavaScript',
    descricao: 'JavaScript é uma linguagem de programação utilizada para desenvolver aplicações web e mobile.',
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
  },
  {
    id: 3,
    titulo: 'Redux',
    descricao: 'Redux é uma linguagem de programação utilizada para desenvolver aplicações web e mobile.',
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg",
  },
  {
    id: 4,
    titulo: 'MySQL',
    descricao: 'MySQL é uma linguagem de programação utilizada para desenvolver aplicações web e mobile.',
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
  },
  {
    id: 5,
    titulo: 'Git',
    descricao: 'Git é uma linguagem de programação utilizada para desenvolver aplicações web e mobile.',
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
  },
  {
    id: 6,
    titulo: 'HTML5',
    descricao: 'HTML5 é uma linguagem de programação utilizada para desenvolver aplicações web e mobile.',
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
  },
  {
    id: 7,
    titulo: 'CSS3',
    descricao: 'CSS3 é uma linguagem de programação utilizada para desenvolver aplicações web e mobile.',
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
  },
  {
    id: 8,
    titulo: 'Bootstrap',
    descricao: 'Bootstrap é uma linguagem de programação utilizada para desenvolver aplicações web e mobile.',
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg",
  },
  {
    id: 10,
    titulo: 'NodeJS',
    descricao: 'NodeJS é uma linguagem de programação utilizada para desenvolver aplicações web e mobile.',
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
  },
  {
    id: 11,
    titulo: 'Express',
    descricao: 'Express é uma linguagem de programação utilizada para desenvolver aplicações web e mobile.',
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
  },
  {
    id: 12,
    titulo: 'MongoDB',
    descricao: 'MongoDB é uma linguagem de programação utilizada para desenvolver aplicações web e mobile.',
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
  },
  {
    id: 13,
    titulo: 'Docker',
    descricao: 'Docker é uma linguagem de programação utilizada para desenvolver aplicações web e mobile.',
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
  },
  {
    id: 14,
    titulo: 'Sequelize',
    descricao: 'Sequelize é uma linguagem de programação utilizada para desenvolver aplicações web e mobile.',
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sequelize/sequelize-original.svg",
  },
  {
    id: 15,
    titulo: 'PHP',
    descricao: 'Laravel com PHP',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg',
  },
  {
    id: '16',
    titulo: 'Java',
    descricao: 'Java com spring-boot framework',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg',
  },
  {
    id: '17',
    titulo: 'Python',
    descricao: 'Python',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg',
  },
  {
    id: '18',
    titulo: 'Angular',
    descricao: 'Angular framework',
    src: 'https://img.icons8.com/?size=80&id=6SWtW8hxZWSo&format=png',
  },
  {
    id: '19',
    titulo: 'C#',
    descricao: '.NET core',
    src: 'https://cdn-icons-png.flaticon.com/128/6132/6132221.png',
  }
]

export default tecnologias;